import React, { Component } from 'react'
import { Table, Divider, Tag } from 'antd';

// 序号	
// 流程名称	
// 任务摘要	
// 送达时间
const columns = [
  {
    title: '序号',
    dataIndex: 'name',
    key: 'name',
    // render: text => <a>{text}</a>,
  },
  {
    title: '流程名称',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: '任务摘要',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: '送达时间',
    key: 'tags',
    dataIndex: 'tags',
  },
]

const data = [
  // {
  //   key: '1',
  //   name: 'John Brown',
  //   age: 32,
  //   address: 'New York No. 1 Lake Park',
  //   tags: ['nice', 'developer'],
  // },
  // {
  //   key: '2',
  //   name: 'Jim Green',
  //   age: 42,
  //   address: 'London No. 1 Lake Park',
  //   tags: ['loser'],
  // },
  // {
  //   key: '3',
  //   name: 'Joe Black',
  //   age: 32,
  //   address: 'Sidney No. 1 Lake Park',
  //   tags: ['cool', 'teacher'],
  // },
];

export default class PaymentXin extends Component {
  render() {
    return (
      <Table columns={columns} dataSource={data} />
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/workbench/Factor/tablist/PaymentXin.js